<!-- eslint-disable vuejs-accessibility/label-has-for -->
<template>
  <div class="list-wrapper">
    <div
      role="group"
      :aria-labelledby="filter.label"
      v-for="(filter, index) in filterList"
      :key="filter.label"
    >
      <details class="accordion" v-if="filter.tags.length">
        <summary
          class="accordion__summary"
          aria-expanded="false"
          :id="[filter.label]"
        >
          <span>{{ filter.label }}</span>
          <svg
            class="details__toggle"
            aria-hidden="true"
            width="14"
            height="14"
          >
            <use href="/assets/sprite/icons.svg#arrow-close"></use>
          </svg>
        </summary>
        <div class="details__contents">
          <ul class="tags__wrapper" data-tag-wrapper id="tags__wrapper">
            <li
              v-for="(facet, i) in filter.tags"
              :key="facet.label"
              class="tags__item"
            >
              <input
                type="checkbox"
                :id="mode + index + '-' + i"
                :name="facet.label"
                :value="facet.label"
                v-model="selectedFilters"
              />
              <label :for="mode + index + '-' + i">
                <span class="tags__tag"> {{ facet.label }}</span>
              </label>
            </li>
          </ul>
        </div>
      </details>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductFiltersList',

  props: {
    filterList: {
      type: Object,
      required: true,
    },
    mode: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      selectedFilters: [],
    };
  }
};
</script>
